import { render } from "./ContentCopy.vue?vue&type=template&id=0e8bd3c4"
import script from "./ContentCopy.vue?vue&type=script&lang=js"
export * from "./ContentCopy.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__